<ng-container *ngIf="{label: label$ | async} as data">
    <div class="loading-screen d-flex flex-column justify-content-center align-items-center"
         @bounce
         *ngIf="data.label !== null">
        <img class="loading-screen-spinner mb-3" src="/assets/img/auxi/logo.svg" alt="Nirby Spinner">
        <span class="loading-screen-label">{{data.label}}</span>
    </div>
</ng-container>
